import { Fragment } from "react";
import * as React from "react";
import { Link, useHistory } from "react-router-dom";

interface IBreadcrumbRenderProps {
  label?: string;
}

interface IBreadcrumb {
  label?: string;
  route?: string;
  render?: (props: IBreadcrumbRenderProps) => React.ReactNode;
  routerLink?: boolean;
  backbutton?: Boolean;
  steps?: number;
}

function Breadcrumb({
  crumb: { label, route, render, routerLink = false, backbutton = true, steps = -1 },
  last,
}: {
  crumb: IBreadcrumb;
  last: boolean;
}) {
  let crumb;
  let page_history = null;
  try {
    // eslint-disable-next-line react-hooks/rules-of-hooks
    page_history = useHistory();
  } catch (error) {
    // do nothing
  }
  
  if (render) {
    crumb = render({ label });
  } else if (routerLink && route) {
    crumb = <Link to={route}>{label}</Link>;
  } else if (page_history && routerLink && backbutton){
    crumb =  <a style={{cursor:'pointer'}} onClick={() => page_history.goBack()}>{label}</a>
  }
  else {
    crumb = route ? <a href={route}>{label}</a> : <span>{label}</span>;
  }

  return (
    <Fragment>
      {crumb}
      {last ? " \\ " : ""}
    </Fragment>
  );
}

interface Props {
  crumbs: IBreadcrumb[];
}

function Breadcrumbs({ crumbs }: Props) {
  const breadcrumbs = crumbs.map((bc, i) => (
    <Breadcrumb crumb={bc} key={i} last={i !== crumbs.length - 1} />
  ));

  return (
    <div className="row hidden-xs hidden-sm breadcrumb-wrapper">
      <div className="col-md-12">
        <h2 className="breadcrumbz">{breadcrumbs}</h2>
      </div>
    </div>
  );
}

export default Breadcrumbs;



// WEBPACK FOOTER //
// ./app/javascript/components/core/Breadcrumbs.tsx